export interface ICategoryProductPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: CATEGORYPRODUCT[];
}

export interface CATEGORYPRODUCT {
  id_categoria_producto?: string;
  codigo:string;
  numero_referencia?: string;
  nombre: string;
  estado: boolean;
}

export enum CategoryProducCodeEnum {
  MATERIALES = 'MATERIALES',
  EQUIPOS = 'EQUIPOS',
}
// categoria_producto_data - Flota materiales disponibles OT
